import { Component, OnInit } from '@angular/core';
import { DataService, Leader } from 'src/app/services/data-service.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'leaders',
  templateUrl: './leaders.component.html',
  styleUrls: ['./leaders.component.scss']
})
export class LeadersComponent implements OnInit {
  public bracketSummaries: BracketSummary[] = [];
  public displayLeaderInfo = false;
  public selectedLeader = new Leader();
  public totalSummary: TotalSummary = new TotalSummary();
  
  constructor(public ds: DataService, public translate: TranslateService) { }

  ngOnInit(): void {
    const bracket = this.ds.currentTournament.brackets.find(b => b.level === 0);
    if (bracket) {
      this.ds.getLeaders(bracket.level, bracket.maxCompleteRound ? bracket.maxCompleteRound : 1); 
    }
  }

  public closeLeaderSummary(): void {
    this.displayLeaderInfo = false;
  }

  public onSelectLeader(l: Leader): void {
    this.selectedLeader = l;
    this.bracketSummaries = []; 
    this.totalSummary = new TotalSummary();

    this.ds.currentTournament.brackets.forEach(bracket => {
      let bracketSummary = new BracketSummary();
      bracketSummary = new BracketSummary();
      bracketSummary.bracketId = bracket.id;
      bracketSummary.bracketName = bracket.bracketName;
      bracketSummary.roundSummaries = [];
      bracketSummary.hasElimination = bracket.hasElimRound;

      if(bracket.rounds === null || bracket.rounds == undefined) {return;}
      bracket.rounds.forEach(round => {
        let match = null;
        let team = null;
        for (let j = 0; j < round.matches.length; j++) {
          match = round.matches[j];
          team = round.matches[j].teams.find(t => t.id === l.id);
          if (team) { break; }
        }
        if (team === null || team === undefined) { return; }

        var roundSummary = new RoundSummary() 
        
        roundSummary.round = round.roundNum;
        roundSummary.complete = match.complete;
        roundSummary.bye = match.bye;
        roundSummary.pitchNum = match.pitchNum;
        roundSummary.fieldName = this.ds.currentTournament.fieldName;
        bracketSummary.roundSummaries.push(roundSummary)

        
        if (round.name === 'FINALS') {
          if (match.roundRank === 1) {
            roundSummary.roundString = this.translate.instant('TOURNAMENTS.FINALS');
          } else {
            roundSummary.roundString = this.translate.instant('TOURNAMENTS.THIRDPLACEMATCH')
          }
        } else {
          roundSummary.roundString = round.name;
        }

        roundSummary.score = 0;

        if(team.game === null || team.games === undefined){return;}
        team.games.forEach(g => {
          roundSummary.score += g.score;
          roundSummary.bkh = g.baseKubbsHit;
          
          switch(g.scoreMeaning) {
            case 'WON':
              roundSummary.wins++; 
              this.totalSummary.wins++;
              break;
            case 'LOST':
              roundSummary.losses++;
              this.totalSummary.losses++;
              break;
            case 'TIED':
              roundSummary.tied++; 
              this.totalSummary.ties++;
              break;
            case 'TIED_LEADING':
              roundSummary.tiedLeading++; 
              this.totalSummary.ties++;
              break;
            case 'TIED_TRAILING':
              roundSummary.tiedTrailing++;
              this.totalSummary.ties++;
              break;
          }
        });

        let opp = match.teams.find(t => t.id !== l.id);
        if (opp) {
          roundSummary.opponentName = opp ? opp.name : null;
          roundSummary.opponentScore = 0;
          opp.games.forEach(g => {
            roundSummary.opponentScore += g.score;
            roundSummary.oppBKH = g.baseKubbsHit;

            if(roundSummary.oppBKH > 0 || roundSummary.bkh > 0) {
              roundSummary.opponentName = roundSummary.opponentName + " (" + roundSummary.oppBKH + ")";
            }

          });
        }
        if(this.ds.currentTournament.year < 2023) {
          if (roundSummary.score === roundSummary.opponentScore) {
            roundSummary.summaryString = this.translate.instant('SCORES.TIED');
            roundSummary.className = 'tied';
          } else if (roundSummary.score < 1 && roundSummary.opponentScore < 1) {
            if (roundSummary.score < .5) {
              roundSummary.summaryString = this.translate.instant('SCORES.TIEDTRAILING');
              roundSummary.className = 'tied';
            } else if (roundSummary.score > .5) {
              roundSummary.summaryString = this.translate.instant('SCORES.TIEDLEADING');
              roundSummary.className = 'tied';
            } else {
              roundSummary.summaryString = this.translate.instant('SCORES.TIED'); 
              roundSummary.className = 'tied';
            }
          } else {
            if (roundSummary.score > roundSummary.opponentScore) {
              roundSummary.summaryString = this.translate.instant('SCORES.WIN');
              
              roundSummary.className = 'win';
            } else {
              roundSummary.summaryString = this.translate.instant('SCORES.LOSS');
              roundSummary.className = 'loss';
            }
          }
        } else {
          if (roundSummary.score === roundSummary.opponentScore) {
            roundSummary.summaryString = this.translate.instant('SCORES.TIED');
            roundSummary.className = 'tied';
            if(roundSummary.bkh > 0 || roundSummary.oppBKH > 0) {
              roundSummary.summaryString = roundSummary.summaryString + " (" + roundSummary.bkh + ")"
            }
          } else if ((roundSummary.score < 3 && roundSummary.opponentScore < 3) && (bracket.level<1 && match.numGames<2)) {
            if (roundSummary.score < 1.5) {
              roundSummary.summaryString = this.translate.instant('SCORES.TIEDTRAILING');
              roundSummary.className = 'tied';
            } else if (roundSummary.score > 1.5) {
              roundSummary.summaryString = this.translate.instant('SCORES.TIEDLEADING');
              roundSummary.className = 'tied';
            } else {
              roundSummary.summaryString = this.translate.instant('SCORES.TIED'); 
              roundSummary.className = 'tied';
            }

            if(roundSummary.bkh > 0 || roundSummary.oppBKH > 0) {
              roundSummary.summaryString = roundSummary.summaryString + " (" + roundSummary.bkh + ")"
            }
          } else {
            if (roundSummary.score > roundSummary.opponentScore) {
              roundSummary.summaryString = this.translate.instant('SCORES.WIN');

              roundSummary.className = 'win';
            } else {
              roundSummary.summaryString = this.translate.instant('SCORES.LOSS');
              
              roundSummary.className = 'loss';
            }

            if(roundSummary.bkh > 0 || roundSummary.oppBKH > 0) {
              roundSummary.summaryString = roundSummary.summaryString + " (" + roundSummary.bkh + ")"
            }
          }
        }
          
        

      });

      if (bracketSummary.roundSummaries && bracketSummary.roundSummaries.length > 0) {
        this.bracketSummaries.push(bracketSummary);
      }
    });

    this.displayLeaderInfo = true;
  }
}

class BracketSummary {
  bracketId: number;
  bracketName: string;
  hasElimination = false;
  roundSummaries: RoundSummary[];
}

class RoundSummary {
  round: number;
  bye = false;
  wins = 0;
  losses = 0;
  tied = 0;
  tiedLeading = 0;
  tiedTrailing = 0;
  score = 0;
  bkh = 0;
  opponentScore = 0;
  oppBKH = 0;
  opponentName: string;
  pitchNum = 0;
  fieldName: string;
  complete: boolean;
  roundString: string;
  summaryString: string;
  className: string;
}

class TotalSummary {
  wins = 0;
  losses = 0;
  ties = 0;
}